<template lang="pug">
div
  .des
    .hl-box
      router-link(to='/event')
        img(v-if="$helpers.timingFilter('2025-08-01 00:00')"  src='/new/img/reward8.gif')
        img(v-else  src='/new/img/reward.gif')
      router-link(to='/referral')
        img(src='/new/img/b-referral.png')
      router-link(v-if="isLoggedIn" to='/vip')
        img(src='/new/img/b-vip.png')
      a(v-else href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
        img(src='/new/img/b-vip.png')
      router-link(to='/partners')
        img(src='/new/img/b-partnership.png')
      //- router-link(to='/ambassador')
        img(src='/new/img/b-ambassador.png')
  .mob
    .hl-box
      router-link(to='/event')
        img(v-if="$helpers.timingFilter('2025-08-01 00:00')"  src='/new/img/reward8.gif')
        img(v-else  src='/new/img/reward.gif')
      router-link(to='/referral')
        img(src='/new/img/b-referral.png')
      router-link(v-if="isLoggedIn" to='/vip')
        img(src='/new/img/b-vip.png')
      a(v-else href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
        img(src='/new/img/b-vip.png')
      router-link(to='/partners')
        img(src='/new/img/b-partnership.png')
      //- router-link(to='/ambassador')
        img(src='/new/img/b-ambassador.png')  
</template>
<script>
export default{
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
}
</script>